import { Badge, Box, Heading, HStack } from '@chakra-ui/react';
import { ActivityCompanyReportingRequirementViewModel } from '../types';
import { ReportingRequirementDetailsLink } from './reportingRequirementDetailsLink';

type Props = {
  viewModel: ActivityCompanyReportingRequirementViewModel;
};

export const ReportingRequirementViewModelDisplay = ({ viewModel }: Props) => {
  const comment = viewModel.Comment ?? viewModel.comment ?? '';
  const example = viewModel.Example ?? viewModel.example ?? '';

  return (
    <Box>
      <HStack gap={2} alignItems='center' flexWrap='wrap'>
        <Heading size='xs' padding='2px' margin={0}>
          {viewModel.Name}
        </Heading>
        <ReportingRequirementDetailsLink comment={comment} example={example} />
        {viewModel.IsMandatory && (
          <Badge backgroundColor='red' color='white'>
            Mandatory
          </Badge>
        )}
        {viewModel.IsRequired && (
          <Badge backgroundColor='orange' color='white'>
            Required
          </Badge>
        )}
      </HStack>
    </Box>
  );
};
